/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {
    ISpacierArcadeGameData,
    ISpacierArcadeInitData, ISpacierArcadeServerData
} from "./data/ISpacierArcadeServerData";
import {SASymbols} from "../symbols/SpacierArcadeReelSymbol";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";

export class SpacierArcadeServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseExtraSymbolsOnTop(data: ISpacierArcadeGameData): string[][] {
        let result: string[][] = [],
            i: number;

        for (i = 0; i < data.reels.length; ++i) {
            result[i] = [];
            result[i].push(data.reels[i][0]);
        }

        return result;
    }

    public parseNearWinReels(rawData:ISpacierArcadeGameData):boolean[] {
        // let currentSyms = rawData.reels[1].filter((sym:string, index:number) => {
        //     return (index > 2 && index < 6);
        // });
        // if(currentSyms.includes(SASymbols.W) && rawData.mode === SpacierArcadeGameMode.NORMAL){
        //     rawData.nearWinReels[2] = false;
        // }
        // else if(rawData.mode === SpacierArcadeGameMode.FREESPIN){
        //     rawData.nearWinReels = [false, false, false, false, false];
        // }
        return rawData.nearWinReels; //[false, false, false, false, false]; [true, true, true, true, true];
    }

    public parseSingleWin(rawData:ISpacierArcadeGameData):number {
        if(rawData.payoutMultiplier === 1){
            return parseFloat(rawData.totalSpinWinnings);
        }
        return parseFloat(rawData.totalSpinWinningsNotMultiplied);
    }

    public parseTotalSpinWinnings(rawData:ISpacierArcadeGameData):number {
        return parseFloat(rawData.totalSpinWinnings);
    }

    public parsePayoutMultiplier(rawData: ISpacierArcadeInitData): number {
        return rawData.payoutMultiplier;
    }

    public parseNextMultiplier(rawData: ISpacierArcadeGameData): number {
        return rawData.payoutMultiplierNext !== null ? rawData.payoutMultiplierNext : 1;
    }

    public parseNumberOfRespinPlayed(data: ISpacierArcadeGameData): number {
        return data.numberOfRespinPlayed;
    }

    public parseAccumulatedRoundWin(data: ISpacierArcadeGameData): string {
        return data.accumulatedRoundWin;
    }

    public parsePossibleWinWays(data: ISpacierArcadeInitData): number {
        return data.possibleWinWays;
    }

    public parseNumberOfWinWaysNext(data: ISpacierArcadeGameData): number {
        return data.numberOfWinWaysNextSpin;
    }

    public parseRowsNextSpinCount(rawData: ISpacierArcadeInitData): number {
        return rawData.nbrOfRowsNextSpin;
    }

    public parseRowsCurrentSpinCount(rawData: ISpacierArcadeInitData): number {
        return rawData.nbrOfRows;
    }

    public checkForWinPossibility(rawData: ISpacierArcadeGameData): boolean[]{
        let returnArray:boolean[] = [];
            for (let i:number = 0; i < 4; i++){

            }
        return returnArray;
    }

    public parseNumberOfFreespinsPlayed(rawData:ISpacierArcadeServerData):number | undefined {
        return rawData.freespinPlayed;
    }
}